import React from 'react';
import { Reveal } from '../../motion';
import styles from './Eyebrow.module.css';

type Props = {
  children: React.ReactNode;
  /** White text and line, for sections on a red background. */
  light?: boolean;
  className?: string;
};

/**
 * The small label above every section title: a short red line, then the
 * label in red capitals ("— WHY SAHARI CARGO"). One component so every
 * section uses the same pattern.
 */
const Eyebrow: React.FC<Props> = ({ children, light, className }) => (
  <Reveal as="span" className={[styles.eyebrow, light ? styles.light : '', className ?? ''].join(' ')}>
    {children}
  </Reveal>
);

export default Eyebrow;
